import { fg } from '@atlaskit/platform-feature-flags/fg';
import { ACTIONABLE_FOLLOW_UPS_MARKER } from '@atlassian/conversation-assistant-content-transformer/utils/actionable-follow-ups';
import { type StreamableComponentConfig } from '@atlassian/conversation-assistant-content-transformer/utils/stream-markdown-parser';

import { ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY } from './ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY';

export const getStreamableComponents = (): StreamableComponentConfig[] => [
	{
		key: 'expand',
		startTag: '▞',
		endTag: '▚',
		placeholderTag: '[^expand^]',
		isEnabled: true,
	},
	{
		key: 'chart',
		startTag: '◴',
		endTag: '◶',
		placeholderTag: '[^chart^]',
		isEnabled: true,
	},
	{
		key: 'lumina',
		startTag: '◐',
		endTag: '◑',
		placeholderTag: '\n\n[^lumina^]\n\n',
		isEnabled: fg('rovo_chat_enable_inline_lumina'),
	},
	{
		// Actionable follow-up questions: a single start marker with no end marker —
		// everything after `◈` to the end of the message is the follow-ups payload.
		// An empty endTag tells the parser to capture to end-of-message.
		key: ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY,
		startTag: ACTIONABLE_FOLLOW_UPS_MARKER,
		endTag: '',
		placeholderTag: `\n\n[^${ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}^]\n\n`,
		isEnabled: fg('rovo_chat_actionable_followups_enabled'),
	},
];
